module.exports = __webpack_public_path__ + "img/icon4.5df2a3fb.png";